//
export default [
    'wh_item',
    'wh_pack',
    'wh_packing',
    'wh_promo',
    'wh_tags',
    'wh_product_global_stocks',
    'wh_subfamily',
]
